import React from 'react';
import { Group, Circle, Image as KonvaImage, Text } from 'react-konva';
import useImage from 'use-image';

const Stamp = ({ x, y, stamp, size, styles }) => {
  const [image] = useImage(stamp.type === 'filled' ? styles.image : "");

  return (
    <Group x={x} y={y}>
      {/* Base circle for all stamp types */}
      <Circle
        radius={size / 2}
        fill={styles.backgroundColor}
        stroke={styles.borderColor}
        strokeWidth={styles.borderWidth}
        opacity={stamp.type === "unfilled" ? 0.7 : 1}
      />

      {/* Image for filled stamps */}
      {stamp.type === 'filled' && image && (
        <KonvaImage
          image={image}
          x={-size/2}
          y={-size/2}
          width={size}
          height={size}
        />
      )}

      {/* Text for free stamps */}
      {stamp.type === 'free' && (
        <Text
          text={styles.text || 'FREE'}
          x={-size/2}
          y={-size/2}
          width={size}
          height={size}
          align="center"
          verticalAlign="middle"
          fontSize={styles.fontSize || size * 0.3}
          fontFamily={styles.fontFamily || 'Arial'}
          fill={styles.color || '#000'}
          fontStyle={styles.fontStyle || 'bold'}
        />
      )}
    </Group>
  );
};

const StampsContainer = ({ containerStyles, stampStyles, stamps }) => {
  // Calculate stamp size based on container width and stamps per row
  const stampSize = (containerStyles.width - (containerStyles.gap * (containerStyles.stampsPerRow - 1))) / containerStyles.stampsPerRow;

  // Position stamps in a grid
  const stampPositions = stamps.map((stamp, index) => {
    const row = Math.floor(index / containerStyles.stampsPerRow);
    const col = index % containerStyles.stampsPerRow;

    return {
      ...stamp,
      x: col * (stampSize + containerStyles.gap) + stampSize / 2,
      y: row * (stampSize + containerStyles.gap) + stampSize / 2
    };
  });

  return (
    <Group>
      {stampPositions.map((stamp) => (
        <Stamp
          key={stamp.id}
          x={stamp.x}
          y={stamp.y}
          stamp = {stamp}
          size={stampSize}
          styles={stampStyles[stamp.type]}
        />
      ))}
    </Group>
  );
};

export default StampsContainer;
